import { home_top_banner } from './seq';
import { updateFrames, home_top_banner_anim } from './anime';
import { VideoSprite } from './video_sprites';

let banner;
let sprites = [];

function initSprites() {
    banner = new VideoSprite({
        name: "banner",
        container: document.querySelector(".big-banner"),
        backgroundColor: 0x000000,
        parent: document.querySelector(".big-banner")
    }, home_top_banner);

    sprites.push(banner);
};

function lazyLoadSprites() {

    let totalLoaded = 0;

    for (let i = 0; i < sprites.length; i++) {
        let videoSprite = sprites[i];
        if (videoSprite.videoLoaded) {
            totalLoaded++;
        } else {
            videoSprite.load(lazyLoadSprites);
            break;
        }
    }
}

$(document).ready(function () {
    if ($(".big-banner").length) {
        initSprites();
        home_top_banner_anim(banner);
        lazyLoadSprites();
    }
})